/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { ChangeModalAlarms, ChangeControlShowCaption } from "../../Redux/Actions";
import { ChangeControlTourActive } from "../../Redux/Actions/controlActions";

/* 🔧 UTILS */
import { createStep } from "./index";

const isMobile = window.matchMedia("(max-width: 1080px)").matches;
const isLandscape = window.matchMedia("(orientation: landscape)").matches;

export const controlSteps = (t) => [
    createStep({
      selector: isLandscape && isMobile ? '#selects-landscape' : '#selects',
      stepNumber: 1,
      titleKey: t("tour.control.selects.title"),
      textKey: t("tour.control.selects.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: '#caption-button',
      stepNumber: 2,
      titleKey: t("tour.control.caption.title"),
      textKey: t("tour.control.caption.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: '#caption',
      stepNumber: 3,
      titleKey: t("tour.control.caption.title"),
      textKey: t("tour.control.caption.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#alarms-landscape' : '#alarms',
      stepNumber: 4,
      titleKey: t("tour.control.alarms.title"),
      textKey: t("tour.control.alarms.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: '#alarms-modal',
      stepNumber: 5,
      titleKey: t("tour.control.alarms.title"),
      textKey: t("tour.control.alarms.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#icons-landscape' : '#icons',
      stepNumber: 6,
      titleKey: t("tour.control.icons.title"),
      textKey: t("tour.control.icons.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#pump-mode-landscape' : '#pump-mode',
      stepNumber: 7,
      titleKey: t("tour.control.pump-mode.title"),
      textKey: t("tour.control.pump-mode.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#submit-changes-landscape' : '#submit-changes',
      stepNumber: 8,
      titleKey: t("tour.control.submit-changes.title"),
      textKey: t("tour.control.submit-changes.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#switch-landscape' : '#switch',
      stepNumber: 9,
      titleKey: t("tour.control.switch.title"),
      textKey: t("tour.control.switch.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '.detailed-landscape' : '.detailed',
      stepNumber: 11,
      titleKey: t("tour.control.detailed.title"),
      textKey: t("tour.control.detailed.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#modules-landscape' : '#modules',
      stepNumber: 12,
      titleKey: t("tour.control.modules.title"),
      textKey: t("tour.control.modules.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: '#pinned-module',
      stepNumber: 13,
      titleKey: t("tour.control.pinned-module.title"),
      textKey: t("tour.control.pinned-module.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
    createStep({
      selector: isLandscape && isMobile ? '#chart-landscape' : '#chart',
      stepNumber: 14,
      titleKey: t("tour.control.chart.title"),
      textKey: t("tour.control.chart.text"),
      customClose: () => {
        store.dispatch(ChangeControlTourActive(false));
      }
    }),
]

export const handleControlPrevStep = (currentStep, setCurrentStep) => {
  const stepActions = {
    2: () => {
      store.dispatch(ChangeControlShowCaption(false));
      setCurrentStep(1);
    },
    3: () => {
      if (isLandscape && isMobile) {
        setCurrentStep(0);
      } else {
        store.dispatch(ChangeControlShowCaption(true));
        setCurrentStep(2);
      }
    },
    4: () => {
      store.dispatch(ChangeModalAlarms(false));
      setCurrentStep(3);
    },
    5: () => {
      const config = document.querySelector("#config");
      config && config.click();
      setCurrentStep(4);
    },
    7: () => {
      const pumpMode = document.querySelector('#pump-mode');
      pumpMode ? setCurrentStep(6) : setCurrentStep(5);
    },
    9: () => {
      const checkbox = document.querySelector('#input-switch');
      checkbox && checkbox.click();
      setCurrentStep(8);
    },
    12: () => {
      if (isLandscape && isMobile) {
        setCurrentStep(10);
      } else {
        setCurrentStep(11);
      }
    }
  };
  
  if (stepActions[currentStep]) {
      stepActions[currentStep]();
  } else {
      setCurrentStep(currentStep - 1);
  }
};

export const handleControlNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
  const stepActions = {
    0: () => {
      if (isLandscape && isMobile) {
          setCurrentStep(3);
      } else {
          setCurrentStep(1);
      }
    },
    1: () => {
      store.dispatch(ChangeControlShowCaption(true));
      setCurrentStep(2); 
    },
    2: () => {
      store.dispatch(ChangeControlShowCaption(false));
      setCurrentStep(3);
    },
    3: () => {
      const config = document.querySelector("#config");
      config && config.click();

      setCurrentStep(4);
    },
    4: () => {
      store.dispatch(ChangeModalAlarms(false));
      setCurrentStep(5);
    },
    5: () => {
      const pumpMode = document.querySelector('#pump-mode');
      pumpMode ? setCurrentStep(6) : setCurrentStep(7);
    },
    7: () => {
      if (isLandscape && isMobile) {
          setCurrentStep(10);
      } else {
          setCurrentStep(8);
      }
    },
    8: () => {
      const checkbox = document.querySelector('#input-switch');
      checkbox && checkbox.click();
      setCurrentStep(9);
    },
    12: () => {
      store.dispatch(ChangeControlTourActive(false));
      setIsOpen(false);
      setCurrentStep(0); 
    }
  };

  if (stepActions[currentStep]) {
      stepActions[currentStep]();
  } else {
      setCurrentStep(currentStep + 1);
  }
};
